module.exports = __webpack_public_path__ + "img/success-medication-blue.04e526f9.svg";